export default __webpack_public_path__ + "static/media/G0000.47bb21c9.png";